import { useTranslation } from 'react-i18next'

import { resetAndReload } from '@containers/main/main-utils'
import { useApi } from '@core/api'
import { AccessViewMode } from '@core/main-state'
import { addSnack } from '@core/snack/snack-state'
import { useMutation } from '@tanstack/react-query'

const keys = {
  setViewMode: ['user', 'setViewMode'],
}

// Ordered most -> least privileged, mirroring VIEW_MODE_RANK on the backend.
export const VIEW_MODES: AccessViewMode[] = ['internal_admin', 'customer_admin', 'customer_user']

// Compile-time mapping, so `t(VIEW_MODE_LABEL_KEYS[mode])` stays typed.
export const VIEW_MODE_LABEL_KEYS = {
  internal_admin: 'view_mode_internal_admin',
  customer_admin: 'view_mode_customer_admin',
  customer_user: 'view_mode_customer_user',
} as const satisfies Record<AccessViewMode, string>

export const useSetViewMode = () => {
  const api = useApi()
  const { t } = useTranslation('common', { keyPrefix: 'settings' })

  return useMutation({
    mutationKey: keys.setViewMode,
    mutationFn: async (viewMode: AccessViewMode) => {
      const { data } = await api.setSelfViewMode({ body: { viewMode }, throwOnError: true })

      return data
    },
    onSuccess: () => {
      addSnack({ message: t('view_mode_switched'), severity: 'info' })

      resetAndReload()
    },
    onError: () => {
      addSnack({ message: t('view_mode_failed'), severity: 'error' })
    },
  })
}
